// simple wrapper for api calls - may wish to add logging at some point
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

const consoleLog = messageToLog => (SR.log ? SR.log(messageToLog) : false);

export default {
  // patch: checked => new Promise((resolve, reject) => setTimeout(() => resolve(checked), 500)),
  get: url => axiosInstance
    .get(url)
    .then(response => response.data.data)
    .catch((error) => {
      consoleLog(error);
      return Promise.reject(error);
    }),
  patch: (url, data) => axiosInstance
    .patch(url, data)
    .then(response => response.data.data)
    .catch((error) => {
      consoleLog(error);
      return Promise.reject(error);
    }),
  post: (url, data) => axiosInstance
    .post(url, data)
    .then(response => response.data.data)
    .catch((error) => {
      consoleLog(error);
      return Promise.reject(error);
    }),
};
